<template>
  <div>
    <vggrid ref="xGrid" :random="Math.floor(Math.random() * 999999)" :list="pgCrossList" tableheight="600" flexname=""
            :cols="pgCols"
            :showfooter="false" :showPage="false" :resizable="true"  :mergeRow='mergeRow'>
      <!--<template slot="btn" v-if="isEdit">-->
        <!--<vxe-button class="vxe-btn" @click="save" :loading="btnLoading">保存222</vxe-button>-->
      <!--</template>-->
    </vggrid>
    <div class="exscore-footbtn" v-if="isEdit">
      <span style="font-size:13px;color:red;">温馨提醒：为保证打分准确保存，过程中请定期保存或对某一项对比打完后保存一次！</span><vxe-button type='primary' class="vxe-btn" @click="save" :loading="btnLoading">保存</vxe-button>
    </div>
    <div class="split-line"></div>
    <div class="exscore-container">
      <vggrid :random="Math.floor(Math.random() * 999999)" :list="pgsList" flexname="" :cols="pgsCols"
              :showfooter="false" :showPage="false" :resizable="true">
        <template slot="btn">
          <div class="exscore-topbtn">
            <div class="exscore-topbtn-title">我的评分汇总</div>
            <div class="exscore-topbtn-btn" v-if="isEdit">
              <vxe-button type='primary' class="vxe-btn" @click="submit" :loading="btnLoading">提交</vxe-button>
            </div>
          </div>
        </template>
      </vggrid>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  export default {
    name: 'exPqcCheckIndex',
    mixins: [common],
    components: {vggrid},
    props: {
      activeName: {}
    },
    data () {
      return {
        // priceModel: '',
        project: {},
        list: [],
        scoreTotalList: [],
        selectList: [],
        pgsuList: [],
        psuComList: [],
        pgCrossList: [],
        pgsList: [],
        btnLoading: false,
        model: {},
        isEdit: true,
        mergeRow:['pgratio','pgparentname','pgchildname'],
        editRules: {},
        pgsCols: [
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false},
          // {field: 'pgspriceasexchange', fieldtype: 'C', title: '价格得分', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pgscommercialasexchange', fieldtype: 'C', title: '评审得分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgsas', fieldtype: 'C', title: '总分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgsdesc', fieldtype: 'C', title: '评分意见', calculExpr: '', editRender: { name: 'input'}},
          { title: '评分意见 ', showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                if (this.isEdit) {
                  return [
                    <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"
                  value={row.pgsdesc}  onChange={this.descInputChange.bind(this, row)}></input>
                ]
                } else {
                  return row.pgsdesc
                }
              }
            }
          }
        ],
        pgCols: []
      }
    },
    async created () {
      await this.getModel()
      this.getPgCols()
      await this.getPgsuCrossList()

    },
    async activated(){
      this.getPgCols()
      await this.getPgsuCrossList()
    },
    watch: {
      async activeName () {
        console.log(this.activeName)
        if(this.activeName === 'apfxdb') {
          this.getPgCols()
          await this.getPgsuCrossList()
        }
      }
    },
    methods: {
      descInputChange (row, e) {
        row.pgsdesc = e.target.value
      },
      async initData () {
        await request({
          url: 'expert/initPgsu',
          method: "post",
          data: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            projectpgstotalrule: this.project.projectpgstotalrule
          }
        })
      },
      // 结果汇总表的提交
      async submit () {
        let index1 = this.pgsList.findIndex(v => +v.psupricecommit !== 1)
        if (index1 > -1) {
          this.$message.warning('项目员未录入提交价格分，请耐心等候!')
          return
        }
        // 提取所有psuid，转换为逗号分隔的字符串
        const psuIds = this.psuComList.map(item => item.psuid).join(',');
        let res = await request({
          method: 'get',
          url: '/expert/getPgsListBy',
          params: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            psuids: psuIds
          }
        })
        if (res.length) {
          let index = res.findIndex(v => !v.pgsuas)
          if (index > -1) {
            this.$message.warning('请对供应商评分并且保存后再提交!')
            return
          }
        }
        // let index = this.pgsList.findIndex(v => !v.pgsas)
        // if (index > -1) {
        //   this.$message.warning('请对供应商评分!')
        //   return
        // }
        this.$confirm('评分完成，提交后，不允许再次评分?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: 'expert/insertPgs',
            method: "post",
            data: {
              pexpertid: this.$store.getters.expertLoginUser.pexpertid,
              projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
              list: this.pgsList
            }
          })
          if (data.issuccess === 1) {
            this.$message.success('保存成功')
            this.isEdit = false
            await this.setPgsList()
            // this.$emit('change')
          } else {
            this.$message.error('保存失败')
          }
        })
      },
      // 评分保存
      async save () {
        let isHaveScore = this.pgsuList.length ? this.pgsuList[0].pgsuas:''
        if (isHaveScore !== '') {
          this.selectList = this.pgsuList
        }
        let index = this.selectList.findIndex(v => v.pgsuas === '')
        if (index > -1) {
          this.$message.warning('供应商得分不能为空!')
          return
        }
        if(this.selectList.length !== this.pgsuList.length) {
          this.$message.warning('供应商得分不能为空!')
          return
        }

        console.log(this.selectList, '---')
        console.log(this.pgsuList, '---')

        let res = await request({
          url: 'expert/updatePgsu',
          method: "post",
          data: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            list: this.selectList
          }
        })

        this.scoreTotalList = res.totalList
        if (res.issuccess === 1) {
          this.$message.success('保存成功')
          await this.setPgsList()
        } else {
          this.$message.error('保存失败')
        }
      },
      // 交叉表的数据
      async getPgsuCrossList () {
        this.pgCrossList = []
        this.loading = true
        // let project = {}
        // project.projectisqcheck = this.project.projectisqcheck
        let res = await request({
          method: 'get',
          url: '/expert/getPgCrossByProjectId',
          params: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            psupqcesresult: 1,
            projectisqcheck: this.project.projectisqcheck
          }
        })
        // 价格项
        // let priceList = res.pgList.filter(v => +v.pgflg === 1)
        // this.priceModel = priceList.length ? priceList[0] : ''
        // 非价格项
        this.pgCrossList = res.pgList.filter(v => +v.pgflg === 2)
        // this.pgCrossList = res.pgList
        this.pgsuList = res.pgsuList
        this.psuComList = res.psuList
        // 构造合计行数据
        // this.setTotalRow(res)
        this.scoreTotalList = res.totalList
        await this.setCrossCols()
        await this.setPgsList()
        this.loading = false
      },
      // 构造合计行数据
      setTotalRow (res) {
        if (res.psuList.length) {
          let tree_total = res.tree.filter(v => +v.pgflg === 2)
          let totallist = res.pgsuList.filter(v => +v.pgflg === 2 && +v.pgsucomid == +res.psuList[0].psucomid)
          this.pgCrossList.push({
            pgparentname: '合计',
            pgratio: tree_total.map(t => Number(t.pgratio)).reduce((a, b) => a + b),
            pgscore: totallist.map(t => Number(t.pgscore)).reduce((a, b) => a + b)
          })
          res.psuList.forEach(com => {
            let comsuasList = this.pgsuList.filter(t => +t.pgsucomid === +com.psucomid && +t.pgflg === 2)
            this.pgsuList.push({
              pgsucomid: com.psucomid,
              pgsuas: comsuasList.map(t => Number(t.pgsuas)).reduce((a, b) => a + b),
              pgname: '合计'
            })
          })
        }
      },
      // 我的预审结论数据
      async setPgsList() {
        await this.getPgsList()
        console.log(this.pgsList.length, '---this.getPgsList()')
        console.log(this.pgsList)
        console.log(this.pgsList[0].pscommercialasexchange, '----this.pgsList[0].pscommercialasexchange')
        if (this.pgsList.length) {
          this.isEdit = false
          if (this.pgsList.length > 0) {
            const allSameComid = this.pgsList.every(item => item.pgscomid === this.pgsList[0].pgscomid)
            console.log(allSameComid)
            if (allSameComid && (this.pgsList[0].pscommercialasexchange === null || this.pgsList[0].pscommercialasexchange === undefined)) {
              this.showAutoRedirectTip()
            }
          }
        } else {
          this.isEdit = true
          if (!this.selectList.length) {
            this.selectList = this.pgsuList
          }
          // projectpgstotalrule 综合评分法的总分规则（1：权重制；2：绝对值）
          // 构造pgsrec-评审人对供应商的评分表的数据
          this.pgsList = this.psuComList.map(v => {
            // 返回价格分商务分技术分的原始分及转换后的分数
            let priceModel =  this.scoreTotalList.find(t => +t.pgsucomid === +v.psucomid && t.parentname === '价格')
            let commercialModel =  this.scoreTotalList.find(t => +t.pgsucomid === +v.psucomid && t.parentname === '评审')
            let technologyModel =  this.scoreTotalList.find(t => +t.pgsucomid === +v.psucomid && t.parentname === '技术')
            let pgspriceas = 0
            let pgscommercialas = 0
            let pgstechnologyas = 0
            let price_pgratio = 0
            let commercial_pgratio = 0
            let technology_pgratio = 0
            let price_pgscorestotal = 0
            let commercial_pgscorestotal = 0
            let technology_pgscorestotal = 0
            // 价格
            if (priceModel) {
              // 权重
              price_pgratio = priceModel.pgratio
              // 原始分
              pgspriceas = priceModel.pgsuastotal
              // 分值总分
              price_pgscorestotal = priceModel.pgscorestotal
            }
            // 商务
            if (commercialModel) {
              // 权重
              commercial_pgratio = commercialModel.pgratio
              // 原始分
              pgscommercialas = commercialModel.pgsuastotal ? commercialModel.pgsuastotal : 0
              // 分值总分
              commercial_pgscorestotal = commercialModel.pgscorestotal
            }
            // 技术
            if (technologyModel) {
              // 权重
              technology_pgratio = technologyModel.pgratio
              // 原始分
              pgstechnologyas = technologyModel.pgsuastotal ? technologyModel.pgsuastotal : 0
              // 分值总分
              technology_pgscorestotal = technologyModel.pgscorestotal
            }
            // 价格/商务/技术的转换分：
            // 转换公式（分值/分值总分）*权重
            let pgspriceasexchange = ((Number(pgspriceas)/100)*Number(price_pgratio))
            // let pgspriceasexchange = +this.project.projectpricecomputebasis === 6 && v.psupricecommit !== 1 ? 0 : v.psupriceasexchange ? Number(v.psupriceasexchange) : 0
            let pgscommercialasexchange = Number(commercial_pgscorestotal) > 0 ? ((Number(pgscommercialas)/Number(commercial_pgscorestotal))*Number(commercial_pgratio)) : 0
            let pgstechnologyasexchange = Number(technology_pgscorestotal) > 0 ? ((Number(pgstechnologyas)/Number(technology_pgscorestotal))*Number(technology_pgratio)) : 0
            return {
              psuid: v.psuid,
              pgscomid: v.psucomid,
              psupricecommit: v.psupricecommit,
              comfullname: v.comfullname,
              pgsprojectid: v.psuprojectid,
              pgspriceas: pgspriceas,
              pgspriceasexchange: pgspriceasexchange.toFixed(2),
              pgscommercialas: pgscommercialas,
              pgscommercialasexchange: pgscommercialasexchange.toFixed(2),
              pgstechnologyas: pgstechnologyas,
              pgstechnologyasexchange: pgstechnologyasexchange.toFixed(2),
              pgsas: (Number(pgspriceasexchange) + Number(pgscommercialasexchange) + Number(pgstechnologyasexchange)).toFixed(2),
              pgsdesc: null,
              pqcesexpertid: this.$store.getters.expertLoginUser.pexpertid,
            }
          })
        }
      },
      getPgCols () {
        if (+this.project.projectpgstotalrule === 1) {
          this.pgCols = [
            // {field: 'pgparentname', fieldtype: 'C', title: '项目', calculExpr: ''},
            // {field: 'pgratio', fieldtype: 'C', title: '分值(百分比)', calculExpr: '',width: 100},
            {field: 'pgchildname', fieldtype: 'C', title: '一级（项目）', calculExpr: ''},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'C', title: '分值', calculExpr: '',width: 80, issum: 1}
          ]
        } else {
          this.pgCols = [
            // {field: 'pgparentname', fieldtype: 'C', title: '项目', calculExpr: ''},
            // {field: 'pgratio', fieldtype: 'F', title: '分值(绝对值)', calculExpr: '',width: 100},
            {field: 'pgchildname', fieldtype: 'C', title: '一级（项目）', calculExpr: ''},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'F', title: '分值', calculExpr: '',width: 80, issum: 1},
          ]
        }
      },
      // 设置交叉表的表头
      async setCrossCols () {
        if (this.psuComList.length) {
          for(let i=0;i<this.psuComList.length;i++) {
            let item = this.psuComList[i]
            this.pgCols.push({
              title:item.comfullname,
              children: [
                {
                  // title: item.appendfilename,
                  slots: {
                    default: 'default',
                    default: ({row}) => {
                      let pgsuas = this.getCrossScore({pgid: row.endpgid, psucomid: item.comid})
                      if (this.isEdit && +row.pgflg === 2) {
                        return [
                          <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"
                        value={pgsuas}  onChange={this.inputChange.bind(this, row,item)}></input>
                        ]
                      } else {
                        return pgsuas
                      }
                    },
                    header: ({ column }) => {
                      return [
                        <span onClick={this.fileClick.bind(this,column,item)} style="color: #409EFF;padding-left:10px">{item.appendfilename}</span>
                    ]
                    }
                  }
                }
              ],
              showOverflow: true
            })
          }
        }
      },
      fileClick (col, item) {
        this.downFile(item.appendurl)
      },
      inputChange (row, column, e) {
        if (Number(e.target.value) > Number(row.pgscore)) {
          this.$message.warning('供应商得分不能大于该项分值！')
          e.target.value = ''
          return
        }
        // let float = /^([+-]?)\d*\.\d+$|(^[0-9]\d*$)/
        // 只保留一位小数
        let float = /^(\d{1,2}(\.\d{1,2})?|100)$/
        if (e.target.value && !(float.test(e.target.value))) {
          this.$message.warning('请输入正确的得分，只保留两位小数！')
          e.target.value = ''
          return
        }
        let pgsu = this.pgsuList.find(v => +v.pgsupgid === +row.endpgid && +v.pgsucomid === +column.comid)
        if (pgsu) {
          let index = this.selectList.findIndex(v => +v.pgsuid === +pgsu.pgsuid)
          if(index === -1) {
            this.selectList.push({
              pgsuid: pgsu.pgsuid,
              pgsupgid: row.endpgid,
              pgsucomid: column.comid,
              pgsuas: e.target.value,
              pgsuexpertid: this.$store.getters.expertLoginUser.pexpertid
            })
          } else {
            this.selectList[index].pgsuas = e.target.value
          }
        }
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
        // await this.initData()
      },
      // 获取已检查结果，把结果值说明返回交叉表
      getCrossScore (item) {
        let model = this.pgsuList.find(v => +v.pgsucomid === +item.psucomid && (+v.pgsupgid === +item.pgid || v.pgname === '合计'))
        return model ? model.pgsuas : ''
      },
      // 汇总表的数据
      async getPgsList () {
        this.pgsList = await request({
          url: 'expert/getPgsByProjectId',
          method: "get",
          params: {
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid
          }
        })
      },
      showAutoRedirectTip() {
        let countdown = 5
        const that = this
        
        console.log('-------------showAutoRedirectTip called, countdown:', countdown)
        
        const updateMessage = () => {
          return `当前项目已推荐唯一通过初审的供应商，无需进行评分，<span id="countdown">${countdown}</span>秒后自动跳转到会签页面`
        }
        
        const MessageBox = this.$msgbox
        MessageBox.alert(updateMessage(), '提示', {
          confirmButtonText: '立即跳转',
          showClose: false,
          type: 'info',
          dangerouslyUseHTMLString: true,
          callback: (action) => {
            console.log('-------------alert callback called, action:', action)
            clearInterval(timer)
            that.$router.push({ name: 'exMeetingSignIndex' })
          }
        })
        
        const timer = setInterval(() => {
          countdown--
          console.log('-------------countdown:', countdown)
          
          const countdownEl = document.getElementById('countdown')
          if (countdownEl) {
            countdownEl.textContent = countdown
          }
          
          if (countdown <= 0) {
            console.log('-------------countdown finished, redirecting...')
            clearInterval(timer)
            MessageBox.close()
            setTimeout(() => {
              that.$router.push({ name: 'exMeetingSignIndex' })
            }, 100)
          }
        }, 1000)
      }
    }
  }
</script>
<style lang="scss">
  .exscore-container {
    margin-top: 20px;
    .exscore-topbtn {
      display: flex;
      align-items: center;
      .exscore-topbtn-title {
        padding-left: 10px;
        text-align: center;
      }
      .exscore-topbtn-btn {
        padding-left: 20px;
      }
    }

  }
  .exscore-footbtn {
     text-align: right;
     padding-top: 10px;
   }
</style>
